import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap'; 
import { FooterComponent } from './components/footer/footer.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { AdminHeaderComponent } from './components/admin-header/admin-header.component';
import { CreatePlayerComponent } from './modals/create-player/create-player.component';
import { TournamentBracketComponent } from './components/tournament-bracket/tournament-bracket.component';
import { ErrorComponent } from './modals/error/error.component';
import { SuccessComponent } from './modals/success/success.component';
import { ConfirmComponent } from './modals/confirm/confirm.component';
import { CreateSeasonComponent } from './modals/create-season/create-season.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReviewDetailsComponent } from './modals/review-details/review-details.component';
import { CreateLeagueComponent } from './modals/create-league/create-league.component';
import { LoginComponent } from './modals/login/login.component';
import { CreateScorerComponent } from './modals/create-scorer/create-scorer.component';
import { CreateLeaguePlayerComponent } from './modals/create-league-player/create-league-player.component';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    AdminHeaderComponent,
    CreatePlayerComponent,
    ErrorComponent,
    SuccessComponent,
    ConfirmComponent,
    CreateSeasonComponent,
    ReviewDetailsComponent,
    CreateLeagueComponent,
    LoginComponent,
    CreateScorerComponent,
    CreateLeaguePlayerComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    NgbDropdownModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    AdminHeaderComponent
  ]
})
export class SharedModule { }
